import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpEditorModule } from '@components/sp-editor';
import { SpPipesModule } from '@common/pipes/pipes.module';

import { WebEditorComponent } from './web-editor.component';

@NgModule({
    imports: [CommonModule, SpEditorModule, SpPipesModule, WebEditorComponent],
    exports: [SpEditorModule, WebEditorComponent],
})
export class WebEditorModule {}
